import { ClassMatchType } from '../../types/enums';
import type { IMatchScheduleItem } from '../../types/schedule';
import { isKnockoutStageMatch } from './scheduleConflictDetector';

type MatchScheduleIntervalLike = {
  match: IMatchScheduleItem;
  startMs: number;
  endMs: number;
};

export function areParallelMedalFinals(
  a: IMatchScheduleItem,
  b: IMatchScheduleItem
): boolean {
  if (a.classId !== b.classId) return false;
  if (!isKnockoutStageMatch(a) || !isKnockoutStageMatch(b)) return false;
  if (a.type !== ClassMatchType.FINAL || b.type !== ClassMatchType.FINAL) return false;
  return a.isGold !== b.isGold;
}

export function hasMedalFinalsSequentialViolation(
  a: MatchScheduleIntervalLike,
  b: MatchScheduleIntervalLike
): boolean {
  const bronze = a.match.isGold ? b : a;
  const gold = a.match.isGold ? a : b;
  if (gold.startMs === bronze.startMs) return false;
  return gold.startMs < bronze.endMs;
}

export function isMedalFinalMatch(match: IMatchScheduleItem): boolean {
  return match.type === ClassMatchType.FINAL && isKnockoutStageMatch(match);
}

export function shouldSkipSwapReverseLegOrdering(
  source: IMatchScheduleItem,
  target: IMatchScheduleItem
): boolean {
  if (areParallelMedalFinals(source, target)) return true;
  return isMedalFinalMatch(source) || isMedalFinalMatch(target);
}
